import { render, staticRenderFns } from "./JSONTemplateEditor.vue?vue&type=template&id=052b261c&scoped=true"
import script from "./JSONTemplateEditor.vue?vue&type=script&lang=js"
export * from "./JSONTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./JSONTemplateEditor.vue?vue&type=style&index=0&id=052b261c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b261c",
  null
  
)

export default component.exports